import * as React from "react";

export const Alert = ({ children, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  return <div role="alert" {...props}>{children}</div>;
};

export const AlertDescription = ({ children, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  return <div {...props}>{children}</div>;
};
